import React from 'react';
import { Feedback } from 'services';
import CaseFeedbackEntry from './CaseFeedbackEntry';
import EvidenceStats from '../header/EvidenceStats';

interface CaseFeedbackProps {
  feedbacks: Feedback[];
}

export const CaseFeedback: React.FunctionComponent<CaseFeedbackProps> = props => {
  return (
    <div>
      <EvidenceStats feedback={props.feedbacks} />
      {props.feedbacks
        .sort((a, b) => new Date(b.feedbackDateTime).getTime() - new Date(a.feedbackDateTime).getTime())
        .map((feedback, index) => (
          <CaseFeedbackEntry key={index} feedback={feedback} />
        ))}
    </div>
  );
};

export default CaseFeedback;
